import { render, staticRenderFns } from "./BuktiBayar.vue?vue&type=template&id=9ac6232c&"
import script from "./BuktiBayar.vue?vue&type=script&lang=js&"
export * from "./BuktiBayar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports